import { styled } from '@/stitches.config';

export const StyledSection = styled('section', {});

export const CardsContainer = styled('div', {
  display: 'flex',
  gap: '$6',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '215px',
  width: '100%',
});

const CardContainer = styled('div', {
  padding: '$8',
  border: '1px solid $coolGray200',
  borderRadius: '$8',
  height: '100%',
  display: 'flex',
  alignItems: 'flex-start',
});

export const LeftCardsColumn = styled(CardContainer, {
  flexDirection: 'column',
  gap: '$8',
  flexBasis: '40%',
});

export const LeftLowerCardsRow = styled('div', {
  display: 'flex',
  gap: '80px',
});

export const MiddleCardsColumn = styled(CardContainer, {
  flexDirection: 'column',
  gap: '$10',
  flexBasis: '20%',
});

export const RightCardsColumn = styled(CardContainer, {
  flexDirection: 'row',
  gap: '64px',
  flexBasis: '40%',
});

export const RightCardColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$10',
  alignItems: 'flex-start',
  height: '100%',
});

export const InfoConsent = styled('span', {
  color: '$darkBlue300',
  fontSize: '$3xxl',
  // figma is not showing the real line height
  // for that reason we will use the same value as fontSize
  // to have the text as the same height
  lineHeight: '$3xxl',
  fontWeight: '$bolder',
});

export const InfoValueConsent = styled('span', {
  color: '$darkBlue400',
  fontSize: '$xxl',
  fontWeight: '$xmedium',
  // figma is not showing the real line height
  // for that reason we will use the same value as fontSize
  // to have the text as the same height
  lineHeight: '$xxl',
});
